module.exports = __webpack_public_path__ + "img/Sectors_Municipal_and_Industrial.1f3e9448.jpg";